module.exports = __webpack_public_path__ + "img/bg-left@2x.c44d62cb.png";